// extracted by mini-css-extract-plugin
export default {"root":"_3y46A","expanded":"_2IdVY"};